import React, { useEffect, useState } from "react";
import "./CandidateTestimony.css";
// import BASE_URL from '../../config';
import { Section2Config } from "../../models/Config";
// import {
//   BASE_URL,
//   GET_CANDIDATE_TESTIMONY_URL,
//   ADD_UPDATE_CANDIDATE_TESTIMONY_URL,
//   DELETE_CANDIDATE_TESTIMONY_URL,
// } from "../../constants/Apis";

// const CandidateTestimonyForm = ({ getApi, updateApi }) => {
//   const [config, setConfig] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch(`${BASE_URL}${GET_CANDIDATE_TESTIMONY_URL}`)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("Nav==>", data);
//                       console.log("==>", JSON.stringify(data));
//                       const configObj = new Section2Config(data);
//         setConfig(configObj); // assume section_3 = candidate say
//         setLoading(false);
//       })
//       .catch((err) => console.error(err));
//   }, [getApi]);

//   if (loading) return <p>Loading...</p>;
//   if (!config) return <p>Failed to load section config</p>;

//   const handleChange = (key, value) => {
//     setConfig({ ...config, [key]: value });
//   };

//   const handleItemChange = (index, field, value) => {
//     const updated = [...config.items];
//     updated[index][field] = value;
//     setConfig({ ...config, items: updated, itemCount: updated.length });
//   };

//   const addItem = () => {
//     setConfig({
//       ...config,
//       items: [
//         ...config.items,
//         { icon: "", title: "", subtitle: "" },
//       ],
//       itemCount: config.items.length + 1,
//     });
//   };

//   const removeItem = (index) => {
//     const updated = [...config.items];
//     updated.splice(index, 1);
//     setConfig({ ...config, items: updated, itemCount: updated.length });
//   };

//   const handleSave = () => {
//     const cleanedConfig = {
//       ...config,
//       items: config.items.filter(
//         (item) =>
//           item.title.trim() !== "" && item.subtitle.trim() !== ""
//       ),
//       itemCount: config.items.filter(
//         (item) =>
//           item.title.trim() !== "" && item.subtitle.trim() !== ""
//       ).length,
//     };

//     fetch(`${BASE_URL}${ADD_UPDATE_CANDIDATE_TESTIMONY_URL}`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ section_3: cleanedConfig }),
//     })
//       .then((res) => res.json())
//       .then(() => alert("Section 3 updated successfully!"))
//       .catch((err) => console.error(err));
//   };

//   return (
//     <div className="candidate-say-form">
//       <h2>Candidate Testimonials (Section 3) Config</h2>

//       {/* Section Title */}
//       <div className="form-group">
//         <label>Section Title</label>
//         <input
//           type="text"
//           value={config.title}
//           onChange={(e) => handleChange("title", e.target.value)}
//         />
//       </div>

//       {/* Items */}
//       <div className="form-group">
//         <label>Items</label>
//         {config.items.map((item, idx) => (
//           <div key={idx} className="object-array-item">
//             <input
//               type="text"
//               placeholder="Icon URL"
//               value={item.icon}
//               onChange={(e) =>
//                 handleItemChange(idx, "icon", e.target.value)
//               }
//             />
//             <input
//               type="text"
//               placeholder="Title"
//               value={item.title}
//               onChange={(e) =>
//                 handleItemChange(idx, "title", e.target.value)
//               }
//             />
//             <input
//               type="text"
//               placeholder="Subtitle"
//               value={item.subtitle}
//               onChange={(e) =>
//                 handleItemChange(idx, "subtitle", e.target.value)
//               }
//             />
//             <button type="button" onClick={() => removeItem(idx)}>
//               Remove
//             </button>
//           </div>
//         ))}
//         <button type="button" onClick={addItem}>
//           + Add Item
//         </button>
//       </div>

//       {/* Save */}
//       <button className="save-btn" onClick={handleSave}>
//         Save Config
//       </button>
//     </div>
//   );
// };

// export default CandidateTestimonyForm;

import {
  BASE_URL,
  GET_CANDIDATE_TESTIMONY_URL,
  ADD_UPDATE_CANDIDATE_TESTIMONY_URL,
  DELETE_CANDIDATE_TESTIMONY_URL,
} from "../../constants/Apis";

const CandidateTestimonyForm = ({ getApi, updateApi }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // Fetch candidate testimony config
  const fetchConfig = () => {
    console.log("AP:I",`${BASE_URL}${GET_CANDIDATE_TESTIMONY_URL}`);
    setLoading(true);
    fetch(`${BASE_URL}${GET_CANDIDATE_TESTIMONY_URL}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError(data.error);
        } else {
          console.log("data->>", data);
          setConfig(data); // assuming API returns proper JSON
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load config");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchConfig();
  }, [getApi]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!config) return <p>No data found</p>;

  const handleChange = (key, value) => {
    setConfig({ ...config, [key]: value });
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...config.items];
    updated[index][field] = value;
    setConfig({ ...config, items: updated, itemCount: updated.length });
  };

  const addItem = () => {
    setConfig({
      ...config,
      items: [...config.items, { icon: "", title: "", subtitle: "" }],
      itemCount: config.items.length + 1,
    });
  };

  // const removeItem = (index) => {
  //   const updated = [...config.items];
  //   updated.splice(index, 1);
  //   setConfig({ ...config, items: updated, itemCount: updated.length });
  // };

  const removeItem = (index) => {
  if (!window.confirm("Are you sure you want to remove this item?")) return;

  fetch(`${BASE_URL}${DELETE_CANDIDATE_TESTIMONY_URL}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ index }), // send index to backend
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        // Remove item from frontend state as well
        const updatedItems = [...config.items];
        updatedItems.splice(index, 1);
        setConfig({ ...config, items: updatedItems, itemCount: updatedItems.length });
        alert(data.message);
      } else {
        alert(data.error);
      }
    })
    .catch((err) => console.error(err));
};

  const handleSave = () => {
    setSaving(true);
    const cleanedItems = config.items.filter(
      (item) => item.title.trim() !== "" && item.subtitle.trim() !== ""
    );
    const cleanedConfig = {
      ...config,
      items: cleanedItems,
      itemCount: cleanedItems.length,
    };

    fetch(`${BASE_URL}${ADD_UPDATE_CANDIDATE_TESTIMONY_URL}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cleanedConfig), // send cleaned JSON
    })
      .then((res) => res.json())
      .then((data) => {
        alert(data.success ? "Config saved successfully!" : "Failed to save");
        fetchConfig(); // refresh after save
        setSaving(false);
      })
      .catch((err) => {
        console.error(err);
        setSaving(false);
      });
  };

  const handleDelete = () => {
    if (!window.confirm("Are you sure you want to delete all items?")) return;

    fetch(`${BASE_URL}${DELETE_CANDIDATE_TESTIMONY_URL}`, {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        alert(data.success ? "Deleted successfully!" : "Failed to delete");
        fetchConfig(); // refresh after delete
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="candidate-say-form">
      <h2>Candidate Testimonials (Section 3) Config</h2>

      {/* Section Title */}
      <div className="form-group">
        <label>Section Title</label>
        <input
          type="text"
          value={config.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />
      </div>

      {/* Items */}
      <div className="form-group">
        <label>Items</label>
        {config.items.map((item, idx) => (
          <div key={idx} className="object-array-item">
            <input
              type="text"
              placeholder="Icon URL"
              value={item.icon}
              onChange={(e) => handleItemChange(idx, "icon", e.target.value)}
            />
            <input
              type="text"
              placeholder="Title"
              value={item.title}
              onChange={(e) => handleItemChange(idx, "title", e.target.value)}
            />
            <input
              type="text"
              placeholder="Subtitle"
              value={item.subtitle}
              onChange={(e) =>
                handleItemChange(idx, "subtitle", e.target.value)
              }
            />
            <button type="button" onClick={() => removeItem(idx)}>
              Remove
            </button>
          </div>
        ))}
        <button type="button" onClick={addItem}>
          + Add Item
        </button>
      </div>

      {/* Save / Delete */}
      <button className="save-btn" onClick={handleSave} disabled={saving}>
        {saving ? "Saving..." : "Save Config"}
      </button>
      <button className="delete-btn" onClick={handleDelete}>
        Delete All
      </button>
    </div>
  );
};

export default CandidateTestimonyForm;
